import { Send, Bookmark, ExternalLink, MessagesSquare, MessageCircle } from 'lucide-react';
import type { NodeCategory } from './nodeCategories';

export const commentAutoReplyNodeCategories: NodeCategory[] = [
    {
        title: 'Resposta',
        description: 'Resposta pública ao comentário',
        nodes: [
            {
                type: 'reply' as any,
                icon: MessageCircle,
                label: 'Resposta Pública',
                description: 'Responder publicamente ao comentário',
                color: 'bg-green-500',
            },
        ],
    },
    {
        title: 'Mensagens Privadas',
        description: 'Enviar via DM ao comentarista',
        nodes: [
            {
                type: 'message',
                icon: Send,
                label: 'Mensagem',
                description: 'Texto simples via DM',
                color: 'bg-blue-500',
            },
            {
                type: 'message_template',
                icon: MessagesSquare,
                label: 'Mensagem com Botões',
                description: 'DM com botões interativos',
                color: 'bg-blue-500',
            },
        ],
    },
    {
        title: 'Controles',
        description: 'Gerenciar fluxo e ações',
        nodes: [
            {
                type: 'tag',
                icon: Bookmark,
                label: 'Tag',
                description: 'Adicionar tag ao lead',
                color: 'bg-emerald-500',
            },
            {
                type: 'go_to' as any,
                icon: ExternalLink,
                label: 'Go To',
                description: 'Redirecionar para outro flow',
                color: 'bg-violet-500',
            },
        ],
    },
];
